(function () {
  'use strict';

  var STATE_ORDER = ['VIC', 'NSW', 'QLD', 'SA', 'WA', 'TAS', 'ACT', 'NT'];
  var STATE_NAMES = {
    VIC: 'Victoria', NSW: 'New South Wales', QLD: 'Queensland', SA: 'South Australia',
    WA: 'Western Australia', TAS: 'Tasmania', ACT: 'Australian Capital Territory', NT: 'Northern Territory'
  };
  var NEAREST_FALLBACK = 5;   // shown when nothing is inside the radius
  var BROWSE_PAGE = 40;       // stores shown per "Show more" when browsing all

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function km(a, b, c, d) {
    var R = 6371, r = Math.PI / 180;
    var x = Math.sin((c - a) * r / 2), y = Math.sin((d - b) * r / 2);
    var h = x * x + Math.cos(a * r) * Math.cos(c * r) * y * y;
    return R * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  }

  function fmtKm(d) {
    if (d < 1) return Math.round(d * 1000) + ' m';
    if (d < 10) return d.toFixed(1) + ' km';
    return Math.round(d) + ' km';
  }

  function titleCase(s) {
    return String(s).toLowerCase().replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); });
  }

  function parseCoords(s) {
    var m = String(s || '').match(/(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)/);
    if (!m) return null;
    var lat = parseFloat(m[1]), lng = parseFloat(m[2]);
    if (lat > -45 && lat < -9 && lng > 112 && lng < 155) return { lat: lat, lng: lng };
    return null;
  }

  function Locator(root) {
    this.root = root;
    this.$ = function (sel) { return root.querySelector(sel); };
    this.el = {
      q: this.$('[data-q]'), go: this.$('[data-go]'), geo: this.$('[data-geo]'),
      radius: this.$('[data-radius]'), chain: this.$('[data-chain]'), chainWrap: this.$('[data-chain-wrap]'),
      choices: this.$('[data-choices]'), status: this.$('[data-status]'), results: this.$('[data-results]')
    };
    this.urls = { pc: root.dataset.postcodesUrl, loc: root.dataset.localitiesUrl };
    this.cache = {};
    this.origin = null;
    this.browseLimit = BROWSE_PAGE;

    this.stores = this.load();
    if (this.el.radius) this.el.radius.value = root.dataset.defaultRadius || '50';
    this.buildChainFilter();
    this.bind();
    this.render();
  }

  Locator.prototype.load = function () {
    var raw = [];
    try { raw = JSON.parse(this.$('[data-rb-sl-data]').textContent || '[]'); }
    catch (e) { this.status('Stockist data could not be read.'); return []; }
    return raw.filter(function (s) { return s && s.name; }).map(function (s) {
      var c = parseCoords(s.coords);
      s.lat = c ? c.lat : null;
      s.lng = c ? c.lng : null;
      s.state = String(s.state || '').toUpperCase().trim();
      s.postcode = String(s.postcode || '').replace(/\D/g, '');
      while (s.postcode.length && s.postcode.length < 4) s.postcode = '0' + s.postcode;
      return s;
    });
  };

  Locator.prototype.status = function (msg) { this.el.status.textContent = msg || ''; };

  Locator.prototype.fetchJson = function (key) {
    var self = this;
    if (this.cache[key]) return Promise.resolve(this.cache[key]);
    return fetch(this.urls[key]).then(function (r) {
      if (!r.ok) throw new Error('lookup ' + r.status);
      return r.json();
    }).then(function (d) { self.cache[key] = d; return d; });
  };

  // Stores entered without coordinates fall back to their postcode centre.
  Locator.prototype.fillMissingCoords = function () {
    var need = this.stores.filter(function (s) { return s.lat == null; });
    if (!need.length) return Promise.resolve();
    return this.fetchJson('pc').then(function (pc) {
      need.forEach(function (s) {
        var p = pc[s.postcode];
        if (p) { s.lat = p[0]; s.lng = p[1]; }
      });
    });
  };

  Locator.prototype.buildChainFilter = function () {
    if (!this.el.chain) return;
    var chains = [];
    this.stores.forEach(function (s) { if (s.chain && chains.indexOf(s.chain) === -1) chains.push(s.chain); });
    if (chains.length < 2) return;
    chains.sort();
    this.el.chain.insertAdjacentHTML('beforeend', chains.map(function (c) {
      return '<option value="' + esc(c) + '">' + esc(c) + '</option>';
    }).join(''));
    this.el.chainWrap.hidden = false;
  };

  Locator.prototype.bind = function () {
    var self = this;
    this.el.go.addEventListener('click', function () { self.search(); });
    this.el.q.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); self.search(); }
    });
    this.el.geo.addEventListener('click', function () { self.locate(); });
    this.el.radius.addEventListener('change', function () { self.render(); });
    if (this.el.chain) this.el.chain.addEventListener('change', function () { self.browseLimit = BROWSE_PAGE; self.render(); });

    this.el.choices.addEventListener('click', function (e) {
      var b = e.target.closest('[data-choice]');
      if (!b) return;
      var o = JSON.parse(b.dataset.choice);
      self.hideChoices();
      self.setOrigin(o.lat, o.lng, o.label);
    });

    this.el.results.addEventListener('click', function (e) {
      if (e.target.closest('[data-more]')) { self.browseLimit += BROWSE_PAGE; self.render(); }
    });
  };

  Locator.prototype.hideChoices = function () {
    this.el.choices.hidden = true;
    this.el.choices.innerHTML = '';
  };

  Locator.prototype.search = function () {
    var self = this;
    var raw = (this.el.q.value || '').trim();
    this.hideChoices();

    if (!raw) { this.origin = null; this.status(''); this.render(); return; }

    var q = raw.toUpperCase().replace(/\s+/g, ' ');
    var pcMatch = q.match(/\b(\d{3,4})\b/);
    this.status('Searching…');

    if (pcMatch) {
      var pc = pcMatch[1];
      while (pc.length < 4) pc = '0' + pc;
      this.fetchJson('pc').then(function (d) {
        var p = d[pc];
        if (!p) { self.noMatch(raw); return; }
        self.setOrigin(p[0], p[1], pc);
      }).catch(function () { self.lookupFailed(); });
      return;
    }

    var stateM = q.match(/\b(NSW|VIC|QLD|SA|WA|TAS|NT|ACT)\b/);
    var wantState = stateM ? stateM[1] : null;
    var term = q.replace(/\b(NSW|VIC|QLD|SA|WA|TAS|NT|ACT)\b/, '').replace(/,/g, ' ').trim().replace(/\s+/g, ' ');
    term = term.replace(/^MT\b/, 'MOUNT').replace(/^ST\b/, 'SAINT');

    this.fetchJson('loc').then(function (rows) {
      var exact = [], prefix = [];
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i]; // [LOCALITY, STATE, POSTCODE, lat, lng]
        if (wantState && r[1] !== wantState) continue;
        if (r[0] === term) exact.push(r);
        else if (r[0].indexOf(term) === 0 && prefix.length < 40) prefix.push(r);
      }

      var pool = exact.length ? exact : prefix;

      // Collapse the same suburb listed under several postcodes into one option.
      var seen = {}, opts = [];
      pool.forEach(function (r) {
        var k = r[0] + '|' + r[1];
        if (seen[k]) return;
        seen[k] = true;
        opts.push(r);
      });

      if (!opts.length) { self.noMatch(raw); return; }
      if (opts.length === 1) {
        var o = opts[0];
        self.setOrigin(o[3], o[4], titleCase(o[0]) + ' ' + o[1]);
        return;
      }
      self.offerChoices(opts.slice(0, 10));
    }).catch(function () { self.lookupFailed(); });
  };

  Locator.prototype.offerChoices = function (opts) {
    var html = '<p>Which one did you mean?</p><div class="rb-sl__choicelist">' + opts.map(function (r) {
      var label = titleCase(r[0]) + ' ' + r[1];
      var payload = esc(JSON.stringify({ lat: r[3], lng: r[4], label: label }));
      return '<button type="button" class="rb-sl__choice" data-choice="' + payload + '">' +
        esc(label) + ' ' + esc(r[2]) + '</button>';
    }).join('') + '</div>';
    this.el.choices.innerHTML = html;
    this.el.choices.hidden = false;
    this.status('');
    var first = this.el.choices.querySelector('button');
    if (first) first.focus();
  };

  Locator.prototype.noMatch = function (raw) {
    this.origin = null;
    this.status('We couldn’t find “' + raw + '”. Try a 4-digit postcode.');
    this.render();
  };

  Locator.prototype.lookupFailed = function () {
    this.origin = null;
    this.status('Search is unavailable right now. Showing all stockists.');
    this.render();
  };

  Locator.prototype.setOrigin = function (lat, lng, label) {
    var self = this;
    this.origin = { lat: lat, lng: lng, label: label };
    this.fillMissingCoords().catch(function () {}).then(function () { self.render(); });
  };

  Locator.prototype.locate = function () {
    var self = this;
    if (!navigator.geolocation) { this.status('Location isn’t available in this browser. Enter a postcode instead.'); return; }
    this.el.geo.disabled = true;
    this.hideChoices();
    this.status('Finding your location…');
    navigator.geolocation.getCurrentPosition(function (p) {
      self.el.geo.disabled = false;
      self.el.q.value = '';
      self.setOrigin(p.coords.latitude, p.coords.longitude, 'your location');
    }, function () {
      self.el.geo.disabled = false;
      self.status('Location access was declined. Enter a postcode or suburb instead.');
    }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
  };

  Locator.prototype.filtered = function () {
    var chain = this.el.chain ? this.el.chain.value : '';
    return this.stores.filter(function (s) { return !chain || s.chain === chain; });
  };

  Locator.prototype.mapsUrl = function (s) {
    var q = [s.name, s.address, s.suburb + ' ' + s.state + ' ' + s.postcode].filter(Boolean).join(', ');
    return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(q);
  };

  Locator.prototype.item = function (s) {
    var addr = [s.address, [s.suburb, s.state, s.postcode].filter(Boolean).join(' ')].filter(Boolean).join(', ');
    return '<li class="rb-sl__item">' +
      '<p class="rb-sl__name">' + esc(s.name) + '</p>' +
      (s._d != null ? '<span class="rb-sl__dist">' + fmtKm(s._d) + '</span>' : '') +
      '<p class="rb-sl__addr">' + esc(addr) + '</p>' +
      '<a class="rb-sl__link" href="' + esc(this.mapsUrl(s)) + '" target="_blank" rel="noopener">' +
        'View on Google Maps<span class="visually-hidden"> (opens in a new tab)</span></a>' +
    '</li>';
  };

  Locator.prototype.render = function () {
    var self = this;
    var stores = this.filtered();
    var out = '';

    if (!this.stores.length) {
      this.el.results.innerHTML = '<p class="rb-sl__empty">No stockists have been added yet.</p>';
      return;
    }

    if (this.origin) {
      var o = this.origin;
      var radius = parseInt(this.el.radius.value, 10) || 50;
      var ranked = stores.filter(function (s) { return s.lat != null; }).map(function (s) {
        var c = Object.assign({}, s);
        c._d = km(o.lat, o.lng, s.lat, s.lng);
        return c;
      }).sort(function (a, b) { return a._d - b._d; });

      var inside = ranked.filter(function (s) { return s._d <= radius; });

      if (inside.length) {
        this.status(inside.length + (inside.length === 1 ? ' stockist' : ' stockists') +
          ' within ' + radius + ' km of ' + o.label + '.');
        out = '<ol class="rb-sl__list">' + inside.map(function (s) { return self.item(s); }).join('') + '</ol>';
      } else if (ranked.length) {
        var near = ranked.slice(0, NEAREST_FALLBACK);
        this.status('No stockists within ' + radius + ' km of ' + o.label + '. Here are the nearest.');
        out = '<ol class="rb-sl__list">' + near.map(function (s) { return self.item(s); }).join('') + '</ol>';
      } else {
        out = '<p class="rb-sl__empty">No stockists match this filter.</p>';
      }
    } else {
      // Browsing: group by state, then suburb.
      var sorted = stores.slice().sort(function (a, b) {
        var sa = STATE_ORDER.indexOf(a.state), sb = STATE_ORDER.indexOf(b.state);
        if (sa !== sb) return (sa < 0 ? 99 : sa) - (sb < 0 ? 99 : sb);
        return (a.suburb + a.name).localeCompare(b.suburb + b.name);
      });
      var shown = sorted.slice(0, this.browseLimit);
      var current = null, open = false;

      shown.forEach(function (s) {
        if (s.state !== current) {
          if (open) out += '</ol>';
          current = s.state;
          out += '<h3 class="rb-sl__group">' + esc(STATE_NAMES[s.state] || s.state) + '</h3><ol class="rb-sl__list">';
          open = true;
        }
        out += self.item(s);
      });
      if (open) out += '</ol>';

      if (sorted.length > shown.length) {
        out += '<div class="rb-sl__more"><button type="button" class="rb-sl__btn rb-sl__btn--ghost" data-more>' +
          'Show more (' + (sorted.length - shown.length) + ' remaining)</button></div>';
      }
      if (!this.el.status.textContent || this.el.status.textContent === 'Searching…') {
        this.status(sorted.length + ' stockists. Search by postcode or suburb to find your nearest.');
      }
      if (!sorted.length) out = '<p class="rb-sl__empty">No stockists match this filter.</p>';
    }

    this.el.results.innerHTML = out;
  };

  function init() {
    document.querySelectorAll('[data-rb-sl]').forEach(function (root) {
      if (root.__rbsl) return;
      root.__rbsl = true;
      new Locator(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();